import { useState } from "react";
import { Button } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../ModalManager";
import { setSessionTargetTime, startSession } from "../../../models/session";

export type PresentationTimeModalProps = {
  boardUid: string;
  sessionUid: string;
  firstItemUid: string;
} & ModalProps;

export function PresentationTimeModal({ boardUid, sessionUid, firstItemUid, closeModal }: PresentationTimeModalProps) {
  const { t } = useTranslation();
  const [minutes, setMinutes] = useState(5);

  const handleStart = async () => {
    await setSessionTargetTime(boardUid, sessionUid, minutes);
    await startSession(boardUid, sessionUid, firstItemUid);
    closeModal();
  };

  return (
    <div className="box">
      <p className="title is-4">{t("modal.presentation.time.title")}</p>
      <div className="field">
        <label className="label">{t("modal.presentation.time.label")}</label>
        <div className="control">
          <input
            className="input"
            type="number"
            min={1}
            value={minutes}
            onChange={(e) => setMinutes(parseInt(e.target.value, 10) || 1)}
          />
        </div>
      </div>
      <div className="field is-grouped">
        <div className="control">
          <Button color="success" onClick={handleStart}>
            {t("modal.presentation.time.start")}
          </Button>
        </div>
        <div className="control">
          <Button className="is-ghost has-text-info" onClick={closeModal}>{t("cancel")}</Button>
        </div>
      </div>
    </div>
  );
}
